module.exports = __webpack_public_path__ + "static/media/icon_back.36f3a56f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_back.svg
// module id = 2414
// module chunks = 7